
/**
 * expires - the  amount of time in seconds for the token to expire
 * refreshCall - The function to call to refresh the token, must retern a attribute for the new Expires time
 * intervalTime - time to check the interval in seconds. Default is 80 seconds
 * onStartInterval - a function to call on a start interval
 * timeOffsetToReset - amount of time in seconds to begin resetting the time
 * onShouldRefresh - a function that returns a boolean on weather it should refresh.  Defaults to true
 * onBeforeRefreshCall - a function that is called before the refresh call
 * onAfterRefreshCall - a function that is called when the refresh occurs, this function takes the refresh response as input
 */
const createRefreshInterval = function (options) {
  options.onStartInterval = options.onStartInterval ? options.onStartInterval : () => {}
  options.onShouldRefresh = options.onShouldRefresh ? options.onShouldRefresh : () => { return true }
  options.onAfterRefreshCall = options.onAfterRefreshCall ? options.onAfterRefreshCall : (refreshData) => {}
  let refreshInterval = setInterval(() => {
    options.onStartInterval()
    let expiredTime = new Date(options.expires)
    let offsetExpiredTime = new Date(options.expires - (options.timeOffsetToReset * 1000))
    let now = new Date()
    let isWithinRefreshWindow = now > offsetExpiredTime && now < expiredTime
    let authorized = options.onShouldRefresh()
    let go = isWithinRefreshWindow && authorized
    console.log({
      isWithinRefreshWindow,
      authorized,
      go,
      expiredTime,
      offsetExpiredTime,
      now
    })
    if (go) {
      options.refreshCall().then(resp => {
        options.onAfterRefreshCall(resp)
        console.log(resp)
        options.expires = new Date().getTime() + (resp.expires * 1000)
        console.log('print options')
        console.log(options)
      })
    }
  }, options.intervalTime * 1000)
  return refreshInterval
}

export default createRefreshInterval



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/RefreshToken.js